<ng-template #rowActions let-item>
  <action-menu [items]="actionMenuItems" (clickAction)="actions[$event.valueOf()].emit({data: item, action: $event.valueOf()})" [actionData]="item"></action-menu>
</ng-template>

<data-table 
customCardClass="min-h-full h-full max-h-full overflow-auto"
[title]="detailsTitle()"
[rows]="data()" 
[columns]="columns" 
[actionsTemplate]="rowActions"
tableActionData="create"
[showActionButton]="true"
(tableActionClick)="actions[$event.valueOf()].emit({action: $event.valueOf()})"></data-table>